import { render } from "./MarketingPressure.vue?vue&type=template&id=c35dbf36&scoped=true"
import script from "./MarketingPressure.vue?vue&type=script&lang=ts"
export * from "./MarketingPressure.vue?vue&type=script&lang=ts"

import "./MarketingPressure.vue?vue&type=style&index=0&id=c35dbf36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c35dbf36"

export default script